import { functions } from './functions.js';

console.log('🧞‍♂️ VisualDX is Magic 🪄');

document.addEventListener("DOMContentLoaded", async () => {
    functions();
});


